<template>
  <section class="problem-section" aria-labelledby="problem-title">
    <div class="problem-inner">
     <p class="problem-subtitle">
          Siamo una startup sport&tech. Lavoriamo perché ogni società sportiva possa organizzare una preparazione atletica strutturata, sicura e sostenibile anche senza grandi budget o figure dedicate
      </p>
      <h2 id="problem-title" class="problem-title">
        Il problema che vediamo ogni giorno
      </h2>
      <div class="problem-stat">
        <p class="stat-number">60.000+</p>
        <p class="stat-description">
          Società sportive in Italia. La maggior parte gestisce la preparazione atletica senza strumenti professionali.
        </p>
      </div>

      <div class="problem-text">
        <p class="problem-body">
          Allenatori che pianificano sessioni a mano la sera prima. Società che rinunciano alla preparazione atletica perché non rientra nel budget. Preparatori che lavorano con gruppi di 30 atleti, livelli diversi, senza uno strumento che li supporti. E nel frattempo, gli atleti non si allenano in maniera adeguata e si infortunano più spesso. Questo è il contesto da cui siamo partiti.
        </p>
      </div>

    </div>
  </section>
</template>

<script>
export default {
  name: 'TheProblemSection'
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/colors.scss";

.problem-section {
  background-color: $primary;
  color: $white;
  width: 100%;
}

.problem-inner {
  max-width: 1440px;
  margin: 0 auto;
  padding: 56px 24px;
  display: flex;
  flex-direction: column;
  gap: 48px;
}

.problem-subtitle {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 400;
  line-height: 1.7;
}

.stat-number {
  margin: 0 0 16px;
  font-size: 64px;
  line-height: 1;
  text-align: center;
  color: $white;
}

.stat-description {
  margin: 0;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 400;
  text-align: center;
  color: $white;
}

.problem-title {
  margin: 0;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  text-align: left;
  color: $white;
}

.problem-text {
  padding: 2rem;
  border: 1px solid $white;
  border-radius: 25px;
}

.problem-body {
  margin: 0;
  font-size: 18px;
  line-height: 1.7;
  font-weight: 400;
  color: $white;
}

@media (min-width: 768px) {
  .problem-inner {
    padding: 64px 40px;
    gap: 56px;
  }
}

@media (min-width: 1440px) {
  .problem-inner {
    padding: 80px 120px;
    display: grid;
    grid-template-columns: 4fr 8fr;
    column-gap: 128px;
    row-gap: 48px;
    align-items: start;
  }

  // Full width: occupano entrambe le colonne
  .problem-subtitle,
  .problem-title {
    grid-column: 1 / -1;
  }

  .problem-text {
    align-self: center;
  }
}
</style>
